import { type FilterMeta } from '@src/components/filter/components';
import { cloneDeep } from 'lodash';
import { type Dimension } from './isValidSavedFilter';

const getValidFilterDimensionMeta = (
  dimensionMeta: FilterMeta['dimensions'],
  allDimensions: Dimension[],
) => {
  let newDimensionMeta = cloneDeep(dimensionMeta);
  const validDimensionSet = new Set(allDimensions.map((it) => it.field));
  newDimensionMeta.forEach((d) => {
    d.fields = d.fields.filter((it) => validDimensionSet.has(it.value));
  });

  newDimensionMeta = newDimensionMeta.filter((it) => it.fields?.length > 0);
  return newDimensionMeta;
};

export default getValidFilterDimensionMeta;
